module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }), _vm._v(" "), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "trip-list"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody'), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Update Time")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Pickup Point")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Dropoff Point")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Budget")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Action")])])])])])])]), _vm._v(" ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_c('input', {
    staticClass: "search-text",
    attrs: {
      "id": "0",
      "type": "text",
      "placeholder": "Search"
    }
  })]), _vm._v(" "), _c('th', [_c('input', {
    staticClass: "search-text",
    attrs: {
      "id": "1",
      "type": "text",
      "placeholder": "Search"
    }
  })]), _vm._v(" "), _c('th', [_c('input', {
    staticClass: "search-text",
    attrs: {
      "id": "2",
      "type": "text",
      "placeholder": "Search"
    }
  })]), _vm._v(" "), _c('th', [_c('input', {
    staticClass: "search-text",
    attrs: {
      "id": "3",
      "type": "text",
      "placeholder": "Search"
    }
  })]), _vm._v(" "), _c('th', [_c('select', {
    staticClass: "search-select",
    attrs: {
      "id": "4"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("..")]), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Done")]), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _c('th')]), _vm._v(" "), _c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("Update Time")]), _vm._v(" "), _c('th', [_vm._v("Pickup Address")]), _vm._v(" "), _c('th', [_vm._v("Drop-off Address")]), _vm._v(" "), _c('th', [_vm._v("Budget")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-684996e4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Trip/TripList.vue
// module id = 169
// module chunks = 2